export default __webpack_public_path__ + "images/731c8f915bad5814df493e5ccf95326d-canoeing_small.webp";